<template>
  <div class="option-object px-4 mt-4" :style="{'width': componentWidth + 'px' }">
    <!-- Start Modal -->

    <!-- START OPTION PANEL-->
    <div
      class="break-words bg-white rounded-lg mb-6 xl:mb-0 shadow h-full border border-solid px-4 pb-4"
      :class="step.panelWidthClass"
      :style="{ 'background-color': panelColor, 'border-color': borderColor }"
    >
      <!-- START SETTINGS VIEW -->

      <div v-if="showSettings == true" class="">
        <div class="flex flex-row-reverse">
          <div @click="showSettings = false">
            <svg-icon
              icon="x"
              class="w-6 h-6 opacity-50 hover:opacity-100 cursor-pointer mt-2"
            />
          </div>
        </div>

        <div class="col-span-6 sm:col-span-3">
          <label for="goto" class="block text-sm font-medium text-gray-700"
            >On selection go to:
          </label>
          <select
            v-model="goto"
            id="goto"
            name="goto"
            autocomplete="goto"
            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option value="next">The next step in sequence</option>
            <option
              :key="index"
              v-for="(item, index) in survey.steps"
              :value="item.id"
            >
              <span class="font-bold">Step {{ index + 1 }}: </span
              >{{ item.title }}
            </option>
            <option value="link">An External link </option>
          </select>
        </div>

        <div v-show="option.goto == 'link'" class="col-span-3 sm:col-span-2">
          <label class="block text-sm font-medium text-gray-700 mt-3">
            Link:
          </label>
          <div class="mt-1 flex rounded-md shadow-sm">
            <input
              type="text"
              class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-md sm:text-sm border border-solid border-gray-300"
              placeholder="http://www.example.com"
              v-model="gotoLink"
            />
          </div>
        </div>

        <hr />
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label class="block text-sm font-medium text-gray-700"
            >Set a custom value:
            <svg-icon
              icon="heroicons/solid/question-mark-circle"
              class="h-4 w-4 inline-block"
              svgClass="inline"
              v-tooltip="'Customize the value shown in your reports'"
            ></svg-icon>
          </label>

          <input
            v-model="value"
            type="text"
            class="py-2 px-3 focus:ring-indigo-500 focus:border-indigo-500 flex-1 block w-full rounded-none rounded-md sm:text-sm border border-solid border-gray-300"
            :placeholder="option.title"
          />
        </div>

        <!-- Hide this for now, until integrations are added 
        <div class="col-span-6 sm:col-span-3 mt-5">
          <label for="mapField" class="block text-sm font-medium text-gray-700"
            >Map choice to custom field:
          </label>
          <select
            v-model="option.mapField"
            id="mapField"
            name="mapField"
            autocomplete="mapField"
            class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          >
            <option default>No integration set.</option>
          </select>
        </div>
        -->
      </div>

      <!--START MAIN VIEW -->

      <div v-else>
        <div class="flex flex-row-reverse justify-between my-handle pt-4">
          <BaseDropDown
            v-on:show-settings="showSettings = true"
            v-on:remove-option="$emit('remove-option', option)"
            v-on:clone-option="$emit('clone-option', option)"
            v-bind:items="[
              {
                event: 'show-settings',
                label: 'Option settings',
                icon: 'heroicons/outline/cog',
              },
              {
                event: 'clone-option',
                args: option,
                label: 'Clone option',
                icon: 'heroicons/outline/duplicate',
              },
              {
                event: 'remove-option',
                args: option.id,
                label: 'Delete option',
                icon: 'heroicons/outline/x-circle',
              },
            ]"
          >
          </BaseDropDown>
        </div>

        <div v-on:click="$emit('open-modal', option)">
          <img
            v-if="option.image == 'link'"
            :src="option.image_link"
            class="display-block mx-auto hover:bg-gray-100 cursor-pointer rounded"
            :class="step.imageHeightClass"
          />
          <svg-inline
            v-else
            class="display-block mx-auto hover:bg-gray-100 cursor-pointer rounded "
            :class="step.imageHeightClass"
            style="width: fit-content"
            :style="{ color: accentColor }"
            :image="image"
          />
        </div>

        <div class="p-4">
          <h5 class="mb-1 text-base font-semibold text-center">
            <click-to-edit
              v-model="title"
              pClass="block mx-auto px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="text-center block px-5 cursor-pointer rounded align-middle w-full"
              :inputStyle="{ 'font-family': survey.fontFamily }"
              :pStyle="{ color: fontColor2, 'font-family': survey.fontFamily, width: 'fit-content', 'min-height': '1.5rem'  }"
            ></click-to-edit>
          </h5>
          <div>
            <div class="text-sm text-center">
              <click-to-edit
              v-model="description"
              pClass="block mx-auto px-5 border border-transparent border-solid hover:border-blue-200 cursor-pointer rounded text-center"
              inputClass="mx-auto text-center block px-5 cursor-pointer rounded align-middle w-full"
              :inputStyle="{ 'font-family': survey.fontFamily }"
              :pStyle="{ color: fontColor2, 'font-family': survey.fontFamily, width: 'fit-content', 'min-height': '1.3rem'  }"
            ></click-to-edit>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { FontFamily } from "@/mixins/FontFamily.js";
import ClickToEdit from "@/components/ClickToEdit.vue";
//import ImageSelectModal from "@/components/ImageSelectModal.vue";
import Option from "@/models/Option";

//import Survey from "@/models/Survey";
//import EventBus from "@/event-bus.js";

export default {
  //mixins: [FontFamily],
  components: {
    ClickToEdit,
    //ImageSelectModal
  },
  data() {
    return {
      showModal: false,
      showSettings: false,
    };
  },
  props: ["survey", "step", "option"],
  computed: {
    componentWidth(){
      return this.step.maxPanelWidth() + 32;
    },
    accentColor() {
      return this.survey.accentColor;
    },
    fontColor() {
      return this.survey.fontColor;
    },
    fontColor2() {
      return this.survey.fontColor2;
    },
    panelColor() {
      return this.survey.panelColor;
    },
    borderColor() {
      return this.survey.borderColor;
    },
    font() {
      return this.survey.font;
    },
    size() {
      return this.step.size;
    },
    goto: {
      get() {
        return this.option.goto;
      },
      set(value) {
        if (value !== this.option.goto) {
          Option.update({ where: this.option.id, data: { goto: value } });
        }
      },
    },
    value: {
      get() {
        return this.option.value;
      },
      set(value) {
        if (value !== this.option.value) {
          Option.update({ where: this.option.id, data: { value: value } });
        }
      },
    },
    gotoLink: {
      get() {
        return this.option.goto_link;
      },
      set(value) {
        if (value !== this.option.goto_link) {
          Option.update({ where: this.option.id, data: { goto_link: value } });
        }
      },
    },
    image: {
      get() {
        return this.option.image;
      },
      set(value) {
        if (value !== this.option.image) {
          Option.update({ where: this.option.id, data: { image: value } });
        }
      },
    },
    imageLink: {
      get() {
        return this.option.image_link;
      },
      set(value) {
        Option.update({
          where: this.option.id,
          data: { image_link: value, image: "link" },
        });
      },
    },

    title: {
      get() {
        return this.option.title;
      },
      set(value) {
        if (value !== this.option.title) {
          Option.update({ where: this.option.id, data: { title: value } });
        }
      },
    },
    description: {
      get() {
        return this.option.description;
      },
      set(value) {
        if (value !== this.option.description) {
          Option.update({
            where: this.option.id,
            data: { description: value },
          });
        }
      },
    },
  },

  methods: {
    closeModal: function() {
      this.showModal = false;
      window.removeEventListener("keydown", this.onEscape);
    },
    openModal: function() {
      this.showModal = true;
      window.addEventListener("keydown", this.onEscape);
    },
    onEscape: function(e) {
      if (this.showModal && e.keyCode === 27) {
        this.closeModal();
      }
    },
  },
  destroyed() {
    window.removeEventListener("keydown", this.onEscape);
  },
};
</script>

<style>
.my-handle {
  cursor: move;
}
</style>
